import PropTypes from "prop-types";
import { Paper, Table, TableContainer } from "@mui/material";
import { mergedTableContainerSx } from "../../utils/adminTableScrollSx";

// Tabella desktop fusa alla barra filtri: nessuno scroll interno, l'unico scroll è
// quello della pagina e l'header (passato gia' stilizzato) resta sticky sulla finestra.
export default function AdminMergedTable({
  head,
  body,
  tableLoading = false,
  tableLayout = "auto",
  size,
  containerSx = {},
}) {
  const sizeProps = size ? { size } : {};
  return (
    <TableContainer component={Paper} elevation={0} sx={{ ...mergedTableContainerSx(tableLoading), ...containerSx }}>
      <Table
        stickyHeader
        sx={{
          width: "100%",
          tableLayout,
          borderCollapse: "separate",
          borderSpacing: 0,
          "& tbody td": { overflow: "hidden", textOverflow: "ellipsis" },
        }}
        {...sizeProps}
      >
        {head}
        {body}
      </Table>
    </TableContainer>
  );
}

AdminMergedTable.propTypes = {
  head: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
  tableLoading: PropTypes.bool,
  tableLayout: PropTypes.oneOf(["auto", "fixed"]),
  size: PropTypes.string,
  containerSx: PropTypes.object,
};
 